import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import AuthLayout from "./components/layouts/AuthLayout";
import Products from "./pages/Products";
import ProtectedRoute from "./components/ProtectRoute";
import Loader from "./components/Loader";
import Orders from "./pages/Orders";
import Users from "./pages/Users";
import DeliveryCompany from "./pages/DeliveryCompany";
import Manager from "./pages/subordinated/Manager";
import Accounts from "./pages/subordinated/Accounts";
import Statistics from "./pages/Statistics";
import ConfirmationPayment from "./pages/payments/ConfirmationPayment";
import ManagementPayment from "./pages/payments/ManagementPayment";
import FallowPayment from "./pages/payments/FallowPayment";
import DeliveryManPayment from "./pages/payments/DeliveryManPayment";
import Spend from "./pages/Spend";
import SheetMapping from "./pages/SheetMapping";
import SheetOrders from "./pages/SheetOrders";

function App() {
  return (
    <>
      <Loader />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><AuthLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="/products" element={<Products />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/users" element={<Users />} />
            <Route path="/delivery-company" element={<DeliveryCompany />} />
            <Route path="/sheet-mapping" element={<SheetMapping />} />
            <Route path="/sheet-orders" element={<SheetOrders />} />
            <Route path="/managers" element={<Manager />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/statistics" element={<Statistics />} />
            <Route path="/payment-confirmation" element={<ConfirmationPayment />} />
            <Route path="/payment-management" element={<ManagementPayment />} />
            <Route path="/payment-fallow" element={<FallowPayment />} />
            <Route path="/payment-deliveryman" element={<DeliveryManPayment />} /> 
            <Route path="/spend" element={<Spend />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
